import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { safeRequestParam } from 'src/utils/Common';
import logger from 'src/utils/logger';

function BayiSearch({ setModel, value, searchParam }) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const [search, setSearchBayi] = React.useState('');

    React.useEffect(() => {
        let active = true;
        let Param = search;
        Param = Param.trim();
        if (Param.length > 0 && open) {
             
            axios.get('/GetArtemisDealers/' + safeRequestParam(Param).toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    if (active) {
                        if (res && res.data && res.data.length > 0) {
                            setOptions(res.data);
                        } else {
                            setOptions([]);
                        }
                    }
                }).catch(error => {
                    if (active) {
                        setOptions([]);
                    }
                    logger.error("Hata detayı:", error.message);
                });
        }
        return () => {
            active = false;
        };
    }, [search, open, loading]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchBayi(searchParam);
        }
    }, [searchParam]);

    const updateModel = model => {
        setModel(model);
        value.ACIKLAMA = model.BAYI_ACIKLAMA;
        value.KUL_BAYI_KODU = model.KUL_BAYI_KODU;
        value.BAYI_KODU = model.BAYI_KODU;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={open}
            value={value?.KUL_BAYI_KODU ? value : null}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.KUL_BAYI_KODU === value.KUL_BAYI_KODU}
            getOptionLabel={(option) => { return option.KUL_BAYI_KODU + ' - ' + option.ACIKLAMA }}
            options={options}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearchBayi(e.target.value) }}
                    variant="outlined"
                    label="Bayi"
                    placeholder="Bayi"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            filterOptions={(options) => options}
            loading={loading}
            onChange={(event, newValue) => {
                if (newValue && newValue.ACIKLAMA) {
                    updateModel(newValue);
                }
            }}

        />
    );
}

export default BayiSearch;
